interface DefaultFilter {
    searchTemplateId?: number;
    templateType?: number;
    searchLocaltion?: number;
    deleteFlag?: number;
}

interface IsSavedDefaultFilterPorps {
    /** 筛选器 */
    filter?: DefaultFilter;
    /** 筛选列表类型 */
    filterType?: number;
    /** 数据源 */
    templateType?: DefaultFilter['templateType'];
}

export const isSavedDefaultFilter = (props: IsSavedDefaultFilterPorps): boolean => {
    const { filter, templateType, filterType } = props;

    // 默认的逻辑，1.数据源对上；2.搜索位置对上；3.默认开关开启（ 0 为开启）
    return (
        filter?.templateType === Number(templateType) &&
        filter?.searchLocaltion === Number(filterType) &&
        filter?.deleteFlag === 0
    );
};

interface Filter {
    id?: number;
    status?: number;
}

interface IsDefaultFilterPorps {
    /** 筛选器 */
    filter?: Filter;
    /** 筛选器 */
    savedDefaultFilter?: DefaultFilter;
    /** 额外的条件 */
    extraCondition?: boolean;
}

export const isDefaultFilter = (props: IsDefaultFilterPorps): boolean => {
    const { filter, savedDefaultFilter, extraCondition = true } = props;

    // 默认的逻辑，1.当前筛选器与保存的默认筛选器id一致；2.当前筛选器的状态为开启
    return filter?.id === savedDefaultFilter?.searchTemplateId && extraCondition;
};
